import React, {useEffect, useState} from "react"
import {Outlet, useLocation} from "react-router";
import "./settings.scss"
import Heading from "../../../components/dashboard/heading-component/Heading";
import {Link, useNavigate} from "react-router-dom";
import {Col, Row} from "react-bootstrap"
import {BsChevronRight} from "react-icons/bs";
import ActionModal from "../../../components/common/modals/action-modal/ActionModal";
import {useUser} from "../../../providers/UserContext";
import {UserAuthService} from "../../../services/user-auth-api.service";
import {notification} from "antd";
import {CloseRoundedCheck, RoundedCheck} from "../../../../assets/icons/defaultIcons";

export default function Settings() {
    const navigate = useNavigate()
    const [currentRoute, setCurrentRoute] = useState('');
    const [deleteAccount, setDeleteAccount] = useState(false)
    const [loader, setLoader] = useState(false)
    const location = useLocation();
    const {handleLogout} = useUser()
    const [logoutModal, setLogoutModal] = useState();

    const logout = () => {
        setLoader(true)
        setTimeout(()=>{
            handleLogout()
            navigate('/login')
            setLoader(false)
        },3000)
    }


    const AnalyticsContent = [
        {
            id:1,
            type: 'Merchandise',
            elements: [
                {
                    key: '/settings/change-password',
                    route: '/settings/change-password',
                    label:  'Change Password',
                    allow: ['artist','fan','venue'],
                },
                {
                    key: '/settings/terms-and-conditions',
                    route: '/settings/terms-and-conditions',
                    label:  'Terms & Conditions',
                    allow: ['artist','fan','venue'],
                },
                {
                    key: '/settings/privacy-policy',
                    route: '/settings/privacy-policy',
                    label: 'Privacy Policy',
                    allow: ['artist','fan','venue'],
                },
                {
                    key: '/settings/faqs',
                    route: '/settings/faqs',
                    label:  'FAQs',
                    allow: ['artist','fan','venue'],
                },
            ]
        },
    ]


    useEffect(() => {
        setCurrentRoute(location.pathname);
    }, [location]);


    async function DeleteAccount() {
        setLoader(true)
        const payload = {
            accountDeleteReason:"Other"
        }
        const response = await UserAuthService.DeleteUser( payload)
        if (response){
            notification.success({
                message: "Success",
                description: response.data?.data?.message,
                placement: "topRight",
                icon: <RoundedCheck/>,
                duration: 2,
            });
            handleLogout()
            navigate('/login')
            setLoader(false)
            setDeleteAccount(false);
        }
        else{
            notification.error({
                message: "Failed",
                description: response.data?.data?.message,
                placement: "topRight",
                icon: <CloseRoundedCheck/>,
                duration: 2,
            });
            setLoader(false)
            setDeleteAccount(false);
        }
    }

    return(
        <div className={'analytics-dashboard'}>
            <div className={'event-section'}>
            </div>
            <Heading heading={'Settings'} back={false}/>
            <div>
                <Row>
                    <Col md={12} lg={5} xl={4} xxl={3}>
                        <div className={'nested-sidebar'}>
                            {
                                AnalyticsContent.map((item, index) => {
                                    return (
                                        <>
                                            <ul>
                                                {
                                                    item.elements.map((data, index) => {
                                                        return (
                                                            <li key={data.key}>
                                                                <Link className={`nav-link ${currentRoute.includes(data.route) && 'active'}`} to={data.route}>
                                                                    {data.label} <span><BsChevronRight /> </span>
                                                                </Link>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </>
                                    )
                                })
                            }
                            <p className={'extra-option'} onClick={()=>{setDeleteAccount(true)}}>Delete Account</p>
                            <p className={'extra-option'} onClick={()=>{setLogoutModal(true)}}>Logout</p>
                        </div>
                    </Col>
                    <Col md={12} lg={7} xl={8} xxl={9} className={'mt-5 mt-lg-0'}>
                        <div className={'nested-sidebar-content'}>
                            <Outlet/>
                        </div>
                    </Col>
                </Row>

            </div>

            <ActionModal
                show={deleteAccount}
                close={setDeleteAccount}
                modalHeading={'Delete Account'}
                modalText={'Are you sure you want to delete?'}
                cancelBTnText={'Cancel'}
                actionBTnText={'Delete'}
                // loader={loader}
                actionBtnFunc={()=>{
                    DeleteAccount()
                }}
                loader={loader}
            />

            <ActionModal
                show={logoutModal}
                close={setLogoutModal}
                modalHeading={'Logout'}
                modalText={'Are you sure you want to logout this account?'}
                cancelBTnText={'Cancel'}
                actionBTnText={'Logout'}
                loader={loader}
                actionBtnFunc={() => {
                    logout()
                }}
            />

        </div>
    )
}